import axios from 'axios';
import { getBackendBaseUrl } from './api';

/**
 * Service pour l'exportation des données utilisateur conformément à la Loi 25 du Québec
 * sur la protection des renseignements personnels
 */
const userDataExportService = {
  /**
   * Exporte toutes les données d'un utilisateur au format JSON
   * @param {string} userId - L'ID de l'utilisateur
   * @returns {Promise<boolean>} - True si l'exportation a réussi
   */
  exportUserData: async (userId) => {
    try {
      console.log(`Exportation des données pour l'utilisateur avec ID: ${userId}`);
      
      // Récupérer le token d'authentification
      const token = localStorage.getItem('token');
      
      // Faire une requête pour récupérer toutes les données de l'utilisateur
      const response = await axios({
        url: `${getBackendBaseUrl()}/api/users/${userId}/export-data`,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'x-auth-token': token
        }
      });
      
      // Vérifier que la réponse est bien un blob
      if (!(response.data instanceof Blob)) {
        console.error('La réponse n\'est pas un blob:', response.data);
        throw new Error('Format de réponse invalide');
      }
      
      // Créer un URL pour le blob et déclencher le téléchargement
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Nommer le fichier avec l'ID utilisateur et la date
      const date = new Date().toISOString().split('T')[0];
      link.setAttribute('download', `donnees-utilisateur-${userId}-${date}.json`);
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      console.log('Exportation des données réussie');
      return true;
    } catch (error) {
      console.error('Erreur lors de l\'exportation des données utilisateur:', error);
      
      // Gestion plus précise des erreurs
      if (error.response) {
        console.error('Détails de l\'erreur:', error.response.status, error.response.data);
        throw error.response.data;
      } else if (error.request) {
        console.error('Pas de réponse reçue:', error.request);
        throw new Error('Aucune réponse du serveur. Vérifiez votre connexion internet.');
      } else {
        console.error('Erreur de configuration:', error.message);
        throw new Error(`Erreur lors de la configuration de la requête: ${error.message}`);
      }
    }
  }
};

export default userDataExportService;
